import React from "react";

const SKELETON_ROW_WIDTHS = ["w-2/3", "w-1/2", "w-3/4", "w-2/5"];

export const SelectSpinner = ({ size = "h-4 w-4" }) => (
  <span
    aria-hidden="true"
    className={`${size} inline-block shrink-0 rounded-full border-2 border-gray-200 border-t-cfPrimary motion-safe:animate-spin`}
  />
);

export const SelectLoadingIndicator = () => (
  <div className="flex items-center px-2">
    <SelectSpinner />
  </div>
);

export const SelectLoadingMessage = ({ innerProps, children, selectProps }) => (
  <div {...innerProps} id={selectProps.loadingMessageId} className="text-left">
    <div className="flex items-center gap-2 border-b border-gray-100 px-3 py-2.5 text-sm font-medium text-cfPrimary">
      <SelectSpinner />
      <span>{children}</span>
    </div>
    <div className="py-1" aria-hidden="true">
      {SKELETON_ROW_WIDTHS.map((width, index) => (
        <div key={width} className="px-3 py-2.5">
          <div
            className={`h-3.5 ${width} rounded-md bg-gray-100 motion-safe:animate-pulse`}
            style={{ animationDelay: `${index * 150}ms` }}
          />
        </div>
      ))}
    </div>
    {selectProps.slowLoadingHint && (
      <p className="border-t border-gray-100 bg-gray-50 px-3 py-2 text-xs text-gray-500">
        {selectProps.slowLoadingHint}
      </p>
    )}
  </div>
);

export const SelectLoadingStatus = ({ id, message }) => (
  <span
    id={id}
    role="status"
    aria-live="polite"
    aria-atomic="true"
    className="sr-only"
  >
    {message || ""}
  </span>
);
